<template lang="pug">
  #app
    //- defaultscene
    transition(name="routerView")
      router-view
</template>

<script>
import Navigation from '@/components/Navigation'
import defaultscene from '@/scenes/defaultScene'
import pageScene from '@/scenes/pageScene'
// import router from './router'
// import Vue from 'vue'
export default {
  name: 'App',
  components: { Navigation, defaultscene, pageScene },
  computed: {
    env () {
      return process.env
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
  @import "/style/settings.scss";
  @import "/style/main.scss";

  $fonts-dir: './assets/fonts';
  @font-face {
    font-family: "Body";
    font-weight: 400;
    src: url('#{$fonts-dir}/AvenirNext/AvenirNext-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: "Body";
    font-weight: 400;
    font-style: italic;
    src: url('#{$fonts-dir}/AvenirNext/AvenirNext-Italic.ttf') format('truetype');
  }
  @font-face {
    font-family: "Body";
    font-weight: 700;
    src: url('#{$fonts-dir}/AvenirNext/AvenirNext-Bold.ttf') format('truetype');
  }
  @font-face {
    font-family: "Body";
    font-weight: 700;
    font-style: italic;
    src: url('#{$fonts-dir}/AvenirNext/AvenirNext-BoldItalic.ttf') format('truetype');
  }
  @font-face {
    font-family: "Heading";
    font-weight: 400;
    src: url('#{$fonts-dir}/PTSerif/PTSerif-Regular.ttf') format('woff2'),
      url('#{$fonts-dir}/PTSerif/PTSerif-Regular.ttf') format('woff'),
      url('#{$fonts-dir}/PTSerif/PTSerif-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: "Heading";
    font-weight: 400;
    font-style: italic;
    src: url('#{$fonts-dir}/PTSerif/PTSerif-Italic.ttf') format('woff2'),
      url('#{$fonts-dir}/PTSerif/PTSerif-Italic.ttf') format('woff'),
      url('#{$fonts-dir}/PTSerif/PTSerif-Italic.ttf') format('truetype');
  }
  @font-face {
    font-family: "Heading";
    font-weight: 700;
    src: url('#{$fonts-dir}/PTSerif/PTSerif-Bold.ttf') format('woff2'),
      url('#{$fonts-dir}/PTSerif/PTSerif-Bold.ttf') format('woff'),
      url('#{$fonts-dir}/PTSerif/PTSerif-Bold.ttf') format('truetype');
  }
  @font-face {
    font-family: "Heading";
    font-weight: 700;
    font-style: italic;
    src: url('#{$fonts-dir}/PTSerif/PTSerif-BoldItalic.ttf') format('woff2'),
      url('#{$fonts-dir}/PTSerif/PTSerif-BoldItalic.ttf') format('woff'),
      url('#{$fonts-dir}/PTSerif/PTSerif-BoldItalic.ttf') format('truetype');
  }

  .routerView-enter-active, .routerView-leave-active {
    transition: opacity .2s;
  }
  .routerView-enter, .routerView-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  #maintenance{
    margin: 8rem 0 0 10vw;
    text-align: left;
    #contact{
      display: inline-block;
      margin-top: .4rem;
    }
    #email{
      display: inline-block;
      margin-left: .2rem;
      padding: .1rem .7rem;
      text-decoration: none;
      border: 1px solid get-color(primary-plus2);

      &:hover{
        background: get-color(primary);
        color: white;
        transition: background-color .2s ease-in-out;
      }
    }
    #logo{
      width: 130px;
      margin-bottom: 3.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue